import { Grid } from "@mui/material";
import { librarySelectedTab, setInnCode } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import PageTitle from "components/common/PageTitle";
import Tabs from "components/common/Tabs";
import Typography from "components/common/Typography";
import InncodeDropDown from "components/common/dropdowns/InncodeDropDown";
import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { pageNames } from "utils/Types";
import CreateMyPlan from "../MyPlans/Create";
import { fetchBookmarkPlansIdAsync } from "./Bookmark/Bookmark.slice";
import { adminTabDetails, libraryTabDetails } from "./TabsConfig";

const Library = () => {
  const dispatch = useAppDispatch();
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const selectedTab = useAppSelector((state) => state.app.selectedTab);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const isAbovePropertyUser = useAppSelector((state) => state.app.isAbovePropertyUser);
  const { isMobileScreen } = useContext(ThemeContext);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);

  useEffect(() => {
    if (searchParams.get("redirectTab") === "suggested" && !isAdmin && !isAbovePropertyUser) {
      dispatch(librarySelectedTab(pageNames.suggested));
      navigate("/library", { replace: true });
    }
  }, []);

  const handleTabSelection = (x: number) => {
    dispatch(librarySelectedTab(x));
  };

  const handleOnChange = (value: string) => {
    dispatch(setInnCode(value));
    localStorage.setItem("innCode", value);
  };

  return (
    <>
      <Grid sx={{ backgroundColor: tokens.Background.General.Secondary }}>
        <Grid
          item
          xs={12}
          display={"flex"}
          alignItems="center"
          justifyContent={"center"}
          sx={{ textAlign: "center", gap: "8px" }}
        >
          <Typography variant="body2" color={tokens.Text.General.Secondary}>
            Exploring plans for
          </Typography>

          <InncodeDropDown
            backgroundColor={tokens.Background.General.Color}
            width={isMobileScreen ? "170px" : "284px"}
            height="24px"
            color={tokens.Text.General.Color}
            isAdmin={isAdmin}
            value={innCode}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid
          marginLeft={isMobileScreen ? "40%" : "46%"}
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          sx={{ marginTop: "32px" }}
        >
          <PageTitle label={libraryTabDetails[selectedTab || 0]["label"]} />
          {!isMobileScreen && <CreateMyPlan sx={{ marginLeft: "auto" }} disableInnCode={true} />}
        </Grid>
      </Grid>
      <Tabs
        alignItems="center"
        tabDetails={isAdmin || isAbovePropertyUser ? adminTabDetails : libraryTabDetails}
        defaultTab={selectedTab || 0}
        selectedTab={handleTabSelection}
        onTabChangeFn={fetchBookmarkPlansIdAsync}
      />
      {isMobileScreen && <CreateMyPlan disableInnCode={true} />}
    </>
  );
};

export default Library;
